import { ESiteType } from '../utils/siteType';

type TNewbuildingAnchor = '#promoList' | '#new-promos-anchor-landing';

export const prepareNewbuildingPromosAnchor = (siteType: ESiteType): TNewbuildingAnchor => {
  switch (siteType) {
    case ESiteType.mobile:
    case ESiteType.tablet:
      return '#new-promos-anchor-landing';
    case ESiteType.desktop:
      return '#promoList';
  }
};
